/**
 * Converting Dates to ISO 8601 string without timezone offset
 * 
 * This is a temprorarily function and must be removed when server handles UTC dates propertly
 * Must be replaced with .toISOString() method later
 *
 * @param value
 * @return string
 */

export function toLocalISOString(value: Date): string | null {
    if (!(value instanceof Date)) return;
    return new Date(value.getTime() - value.getTimezoneOffset() * 60000).toISOString();
}
